
import '@/scss/material/settings/user-profile.scss';
import './UserProfilePage.scss';
import { dispatchGetMeetingsCount } from '@/store/dispatchers/uiDispatchers';

import { Component } from 'vue-property-decorator';

import { User } from '@/models/User';
import VueApp from '@/@types/app/VueApp';
import { UserProfileForm } from '@/models/forms/UserProfileForm';
import notificationService from '@/services/NotificationService';

import ProfilePhotoInput from '@/components/layout/inputs/ProfilePhotoInput/ProfilePhotoInput.vue';
import moment from 'moment';

@Component({
  components: {
    ProfilePhotoInput,
  },
})
export default class UserProfilePage extends VueApp {
  loader: any = null;
  user: User = new User();
  userDataForm: UserProfileForm;

  get newUserImageUrl() {
    return this.userDataForm.userProfileImage;
  }

  get userProfileImage() {
    return this.$store.state.user?.profileImage ?? null;
  }

  get userBirthDay(): string | null {
    if (this.userDataForm.birthDay) {
      return moment(new Date(this.userDataForm.birthDay)).format('YYYY-MM-DD');
    }
    return null;
  }

  set userBirthDay(value) {
    if (value) {
      this.userDataForm.birthDay = new Date(value);
      return;
    }
    this.userDataForm.birthDay = null;
  }

  async setProfileImage(photo: File) {
    this.userDataForm.isUserProfileImageDeleted = false;
    if (photo) {
      const uploadedPhoto = (await this.getBase64(photo)) as string;
      this.userDataForm.userProfileImage = uploadedPhoto.replace(/^data:image\/[a-z]+;base64,/, '');
    }
  }

  deleteProfileImage() {
    this.userDataForm.isUserProfileImageDeleted = true;
  }

  async getBase64(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  async save() {
    if (this.userDataForm.passwordOld || this.userDataForm.passwordNew) {
      // validate password
      if (this.userDataForm.passwordConfirm !== this.userDataForm.passwordNew) {
        notificationService.error('Passwords do not match');
        return;
      }
    }

    const loader = this.$loading({});

    await dispatchGetMeetingsCount();

    this.$api
      .updateUser(this.userDataForm)
      .then((res) => {
        this.userDataForm = null;
        notificationService.success('Your profile was successfully updated!');
        // SNAP-2298/2309: changing your password bumps tokenVersion and the API replaces this device's
        // session in the same response, as the HttpOnly cookie. Nothing to adopt here.
        // do not lose user company data.
        if (this.user && this.user.company && !res.data.user.company) {
          res.data.user.company = this.user.company;
        }
        // do not lose user role data.
        if (this.user && this.user.role && !res.data.user.role) {
          res.data.user.role = this.user.role;
        }
        this.user = this.$auth.setUser(res.data.user);
        this.userDataForm = res.data.user;
        this.$store.state.user.profileImagePreview = this.user.profileImage;
      })
      .catch((res) => {
        this.$api.handleResponseError(res);
      })
      .finally(() => {
        loader.close();
      });
  }

  async load() {
    const loader = this.$loading({});

    try {
      const res = await this.$api.getUser();
      this.user = User.parse(res.data.user);
      this.userDataForm = res.data.user as unknown as UserProfileForm;
    } catch (res) {
      this.$api.handleResponseError(res);
    } finally {
      loader.close();
    }
  }

  created() {
    this.load();
  }
}
